import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Platform } from 'ionic-angular';
import { LoggerProvider } from '../../providers/logger/logger';
import * as $ from 'jquery'
import { BridgeMessageFromType } from '../../model/types/bridge-types';

/*
  Generated class for the KeyboardProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
declare var s: any;
declare let Keyboard;

@Injectable()
export class KeyboardProvider {
  keyboardHidden: boolean = true;
  keyboardHeight: any;
  keyboardType: string = 'text';
  localKeyboardType;
  focusHasCalled: boolean = false;
  keyboardHideTimeout;
  private vueProvider: any;
  
  constructor(
    private platform: Platform,
      ) {
    this.addKeyboardListener();
  }

  setVueProvider(vueProvider: any) {
    this.vueProvider = vueProvider;
  }

  showKeyboard(event: any) {
    LoggerProvider.debug(this, 'Show keyboard');
    if (this.platform.is('ios')) {
      this.keyboardHeight = event.keyboardHeight;
      $(document.body).addClass('global-keyboard-visible');
      if(this.keyboardHideTimeout)
        window.clearTimeout(this.keyboardHideTimeout);
    } else {
      $(document.body).addClass('global-keyboard-visible');
    }

    if (this.vueProvider && this.vueProvider.isConnected) {
      this.vueProvider.postMessage(BridgeMessageFromType.KeyboardWillShow, {
        height: event.keyboardHeight,
        duration: event.duration || 300,
        platform: this.platform.is('ios') ? 'ios' : 'android'
      });
    }
  }

  hideKeyboard() {
    LoggerProvider.debug(this, 'Hide keyboard');
    this.keyboardHidden = true;
    if(this.keyboardHideTimeout)
      window.clearTimeout(this.keyboardHideTimeout);

    this.keyboardHideTimeout = window.setTimeout(() => {
      $(document.body).removeClass('global-keyboard-visible');

      if (this.vueProvider && this.vueProvider.isConnected) {
        this.vueProvider.postMessage(BridgeMessageFromType.KeyboardWillHide, {
          duration: 150,
          platform: this.platform.is('ios') ? 'ios' : 'android'
        });
      }
    }, 150);
  }

  addKeyboardListener() {
    window.addEventListener('keyboardWillShow', (event: any) => this.showKeyboard(event));
    window.addEventListener('keyboardWillHide', () => this.hideKeyboard());
  }

  removeKeyboardListener() {
    window.removeEventListener('keyboardWillShow', (event: any) => this.showKeyboard(event));
    window.removeEventListener('keyboardWillHide', () => this.hideKeyboard());
  }
}



// WEBPACK FOOTER //
// ./src/providers/keyboard/keyboard.ts